import { render } from "./authorization.vue?vue&type=template&id=58b64fbf&scoped=true"
import script from "./authorization.vue?vue&type=script&lang=js"
export * from "./authorization.vue?vue&type=script&lang=js"

import "./authorization.vue?vue&type=style&index=0&id=58b64fbf&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b64fbf"]])

export default __exports__